export default "__VITE_ASSET__Dcj6AFvB__"